export class AppClaims {
  constructor(claims: string = null) {
      if (claims != null) {
          this.setClaims(claims);
        }
    }
    setClaims(claims: any = null) {
        this.version = claims["ver"];
        this.AccountReceivableSummary = claims["Account Receivable Summary"] === "1" ? true : false;
        this.ActiveMobileMapLink = claims["Active Mobile Map Link"] === "1" ? true : false;
        this.AdminExpenseMaintenance = claims["AdminExpenseMaintenance"] === "1" ? true : false;
        this.ARReport = claims["ARReport"] === "1" ? true : false;
        this.AssetHistoryReport = claims["AssetHistoryReport"] === "1" ? true : false;
        this.BypassCustomerSigEnforcement = claims["Bypass Customer Sig Enforcement"] === "1" ? true : false;
        this.CanViewMobilePricing = claims["Can View Mobile Pricing"] === "1" ? true : false;
        this.ChangeStatusFrom_Bill_DiscreteReview = claims["Change Status From Bill: Discrete Review"] === "1" ? true : false;
        this.ClockinClockOutTime = claims["Clockin/ClockOutTime"] === "1" ? true : false;
        this.ClosedJobInfoReport = claims["ClosedJobInfoReport"] === "1" ? true : false;
        this.CollectionBulkUpload = claims["Collection Bulk Upload"] === "1" ? true : false;
        this.BulkUploadInventory = claims["BulkUploadInventory"] === "1" ? true : false;
        this.CommonInventory = claims["CommonInventory"] === "1" ? true : false;
        this.CompanyCPI = claims["CompanyCPI"] === "1" ? true : false;
        this.CompanyCPM = claims["CompanyCPM"] === "1" ? true : false;
        this.CompanyCRS = claims["CompanyCRS"] === "1" ? true : false;
        this.ContractEditAdmin = claims["ContractEditAdmin"] === "1" ? true : false;
        this.CreateCPIDispatch = claims["CreateCPIDispatch"] === "1" ? true : false;
        this.CreateCustomers = claims["CreateCustomers"] === "1" ? true : false;
        this.CreateEmployeeNote = claims["CreateEmployeeNote"] === "1" ? true : false;
        this.CreateInvoices = claims["CreateInvoices"] === "1" ? true : false;
        this.CreateNewParts = claims["CreateNewParts"] === "1" ? true : false;
        this.EditPartNumber = claims["EditPartNumber"] === "1" ? true : false;
        this.CreditMemoApprovalTaxesOnly = claims["CreditMemoApprovalTaxesOnly"] === "1" ? true : false;
        this.CurrentJobsReport = claims["CurrentJobsReport"] === "1" ? true : false;
        this.CustomerAddressList = claims["CustomerAddressList"] === "1" ? true : false;
        this.CustomerContractDates = claims["CustomerContractDates"] === "1" ? true : false;
        this.CustomerPaymentReport = claims["CustomerPaymentReport"] === "1" ? true : false;
        this.CustomerSalesSummaryReport = claims["CustomerSalesSummaryReport"] === "1" ? true : false;
        this.CustomerStatementReport = claims["CustomerStatementReport"] === "1" ? true : false;
        this.CustomerStatistics = claims["CustomerStatistics"] === "1" ? true : false;
        this.EditCustomerAutomation = claims["EditCustomerAutomation"] === "1" ? true : false;
        this.DefaultEditMode = claims["DefaultEditMode"] === "1" ? true : true;
        this.DeleteCustomer = claims["DeleteCustomer"] === "1" ? true : false;
        this.DeleteDispatch = claims["DeleteDispatch"] === "1" ? true : false;
        this.DeleteInvoice = claims["DeleteInvoice"] === "1" ? true : false;
        this.DeleteLocation = claims["DeleteLocation"] === "1" ? true : false;
        this.DeleteOrder = claims["DeleteOrder"] === "1" ? true : false;
        this.DeleteQuote = claims["DeleteQuote"] === "1" ? true : false;
        this.DispacthStatusHistoryReport = claims["DispacthStatusHistoryReport"] === "1" ? true : false;
        this.DispatchEquipmentHistory = claims["Dispatch Equipment History"] === "1" ? true : false;
        this.DispatchStatusGauge = claims["Dispatch Status Gauge"] === "1" ? true : false;
        this.DispatchAssignedInReadyForBillingStatusGT1Day = claims["DispatchAssignedInReadyForBillingStatus>1Day"] === "1" ? true : false;
        this.DispatchCreatedReport = claims["DispatchCreatedReport"] === "1" ? true : false;
        this.DispatchLaborReport = claims["DispatchLaborReport"] === "1" ? true : false;
        this.DispatchReport = claims["DispatchReport"] === "1" ? true : false;
        this.DontShowSafetyWarning = claims["Dont Show Safety Warning"] === "1" ? true : false;
        this.DuplicateDispatch = claims["Duplicate Dispatch"] === "1" ? true : false;
        this.DuplicateInvoices = claims["DuplicateInvoices"] === "1" ? true : false;
        this.EditOwnClockedTime = claims["Edit Own Clocked Time"] === "1" ? true : false;
        this.EditUsedPartQty = claims["Edit Used Part Qty"] === "1" ? true : false;
        this.EditAccountNumbers = claims["EditAccountNumbers"] === "1" ? true : false;
        this.EditCategoriesandType = claims["EditCategoriesandType"] === "1" ? true : false;
        this.EditClosedDispatch = claims["EditClosedDispatch"] === "1" ? true : false;
        this.EditCompletedOrder = claims["EditCompletedOrder"] === "1" ? true : false;
        this.EditContractPrice = claims["EditContractPrice"] === "1" ? true : false;
        this.EditCustomerSensitiveData = claims["EditCustomerSensitiveData"] === "1" ? true : false;
        this.EditInvoiceCost = claims["EditInvoiceCost"] === "1" ? true : false;
        this.EditInvoiceDate = claims["EditInvoiceDate"] === "1" ? true : false;
        this.EditClosedDispatchOrder = claims["EditClosedDispatchOrder"] === "1" ? true : false;
        this.EditFullyReceivedOrder = claims["EditFullyReceivedOrder"] === "1" ? true : false;
        this.EditInvoiceChecklist = claims["EditInvoiceChecklist"] === "1" ? true : false;
        this.EditOnCallRegion = claims["EditOnCallRegion"] === "1" ? true : false;
        this.CreateConstructionCredits = claims["CreateConstructionCredits"] === "1" ? true : false;

        this.EditLabor = claims["EditLabor"] === "1" ? true : false;
        this.EditOthersNotes = claims["EditOthersNotes"] === "1" ? true : false;
        this.EditPartsHistory = claims["EditPartsHistory"] === "1" ? true : false;
        this.EditPartQuantity = claims["EditPartQuantity"] === "1" ? true : false;
        this.EditPostedInvoice = claims["EditPostedInvoice"] === "1" ? true : false;
        this.EditPriority = claims["EditPriority"] === "1" ? true : false;
        this.EditProjectManager = claims["EditProjectManager"] === "1" ? true : false;
        this.EditReadyForBillingConstruction = claims["EditReadyForBillingConstruction"] === "1" ? true : false;
        this.EditReadyToPost = claims["EditReadyToPost"] === "1" ? true : false;
        this.EditSecurityTemplates = claims["EditSecurityTemplates"] === "1" ? true : false;
        this.EditStatus = claims["EditStatus"] === "1" ? true : false;
        this.EditWrongParts = claims["EditWrongParts"] === "1" ? true : false;
        this.EditThresholdAlternateNumbers = claims["EditThresholdAlternateNumbers"] === "1" ? true : false;
        
        this.EditPurchaser = claims["EditPurchaser"] === "1" ? true : false;
        this.EmpBreakdownReport = claims["EmpBreakdownReport"] === "1" ? true : false;
        this.EmpCensusReport = claims["EmpCensusReport"] === "1" ? true : false;
        this.EmployeeErrorsReport = claims["EmployeeErrorsReport"] === "1" ? true : false;
        this.EnableTabbedDesktopFeatures = claims["Enable Tabbed Desktop Features"] === "1" ? true : false;
        this.EnterBills = claims["EnterBills"] === "1" ? true : false;
        this.EquipmentHistoryReport = claims["EquipmentHistoryReport"] === "1" ? true : false;
        this.ExpenseMaintenanceSuperUser = claims["Expense Maintenance SuperUser"] === "1" ? true : false;
        this.ExportCorrigo = claims["ExportCorrigo"] === "1" ? true : false;
        this.ExportCostco = claims["ExportCostco"] === "1" ? true : false;
        this.ExportEmployeeList = claims["ExportEmployeeList"] === "1" ? true : false;
        this.ExportEmployeeListCon = claims["ExportEmployeeListCon"] === "1" ? true : false;
        this.ExportRoundys = claims["ExportRoundys"] === "1" ? true : false;
        this.FG2RegularAccess = claims["FG2RegularAccess"] === "1" ? true : false;
        this.FieldJetXEnabled = claims["FieldJetXEnabled"] === "1" ? true : false;
        this.FinancialLockOverride = claims["FinancialLockOverride"] === "1" ? true : false;
        this.InventoryQuantityCostReport = claims["InventoryQuantityCostReport"] === "1" ? true : false;
        this.InvoiceDisputes = claims["InvoiceDisputes"] === "1" ? true : false;
        this.InvoiceLineCost = claims["InvoiceLineCost"] === "1" ? true : false;
        this.InvoiceNeedsApproval = claims["Invoice Needs Approval"] === "1" ? true : false;
        this.InvoiceSalesSummary = claims["Invoice Sales Summary"] === "1" ? true : false;
        this.InvoiceCreatedReport = claims["InvoiceCreatedReport"] === "1" ? true : false;
        this.InvoicePaymentsReport = claims["InvoicePaymentsReport"] === "1" ? true : false;
        this.InvoiceSalesReport = claims["InvoiceSalesReport"] === "1" ? true : false;
        this.InvoiceStatusHistoryReport = claims["InvoiceStatusHistoryReport"] === "1" ? true : false;
        this.InventoryThresholdsReport = claims["InventoryThresholdsReport"] === "1" ? true : false;
        this.LaborLineUnionReport = claims["LaborLineUnionReport"] === "1" ? true : false;
        this.MaintainBenefitMapping = claims["Maintain Benefit Mapping"] === "1" ? true : false;
        this.MaintainAssets = claims["MaintainAssets"] === "1" ? true : false;
        this.MaintainCommissions = claims["MaintainCommissions"] === "1" ? true : false;
        this.MaintainCompanyDefaults = claims["MaintainCompanyDefaults"] === "1" ? true : false;
        this.MaintainCustomerBillingCodeMatrix = claims["MaintainCustomerBillingCodeMatrix"] === "1" ? true : false;
        this.MaintainCustomerPartPricing = claims["MaintainCustomerPartPricing"] === "1" ? true : false;
        this.MaintainCustomers = claims["MaintainCustomers"] === "1" ? true : false;
        this.MaintainDispatches = claims["MaintainDispatches"] === "1" ? true : false;
        this.MaintainEmployeeInfo = claims["MaintainEmployee Info"] === "1" ? true : false;
        this.MaintainExpenses = claims["MaintainExpenses"] === "1" ? true : false;
        this.MaintainFeatures = claims["MaintainFeatures"] === "1" ? true : false;
        this.MaintainInventory = claims["MaintainInventory"] === "1" ? true : false;
        this.MaintainInvoices = claims["MaintainInvoices"] === "1" ? true : false;
        this.MaintainMobileCommunications = claims["MaintainMobileCommunications"] === "1" ? true : false;
        this.MaintainMobileCustomForms = claims["MaintainMobileCustomForms"] === "1" ? true : false;
        this.MaintainParts = claims["MaintainParts"] === "1" ? true : false;
        this.MaintainUserCreditMemoProfiles = claims["MaintainUserCreditMemoProfiles"] === "1" ? true : false;
        this.MaintainZebraPrinters = claims["MaintainZebraPrinters"] === "1" ? true : false;
        this.MergeParts = claims["MergeParts"] === "1" ? true : false;
        this.MaintainPayroll = claims["MaintainPayroll"] === "1" ? true : false;
        this.BulkInsertPayroll = claims["BulkInsertPayroll"] === "1" ? true : false;
        this.MaintainPayrollandTimesheets = claims["MaintainPayrollandTimesheets"] === "1" ? true : false;
        this.MaintainQuotes = claims["MaintainQuotes"] === "1" ? true : false;
        this.UseLocationRateOnApproval = claims["UseLocationRateOnApproval"] === "1" ? true : false;
        this.MaintainSuppliers = claims["MaintainSuppliers"] === "1" ? true : false;
        this.MaintainSystemEvents = claims["MaintainSystemEvents"] === "1" ? true : false;
        this.MaintainTimeOffRequests = claims["MaintainTimeOffRequests"] === "1" ? true : false;
        this.MaintainUserLicenseMapping = claims["MaintainUserLicenseMapping"] === "1" ? true : false;
        this.MaintainUserSessions = claims["MaintainUserSessions"] === "1" ? true : false;
        this.MaintainVehiclePartRequests = claims["MaintainVehiclePartRequests"] === "1" ? true : false;
        this.MaintainVehicles = claims["MaintainVehicles"] === "1" ? true : false;
        this.MaintianOrders = claims["MaintianOrders"] === "1" ? true : false;
        this.MinimumProfitOverrideApproval = claims["MinimumProfitOverrideApproval"] === "1" ? true : false;
        this.MonthlyInvoiceSalesDetail = claims["Monthly Invoice Sales Detail"] === "1" ? true : false;
        this.NoSaveSuccessful = claims["NoSaveSuccessful"] === "1" ? true : false;
        this.OpenContracts = claims["Open Contracts"] === "1" ? true : false;
        this.PendingChangeOrders = claims["Pending Change Orders"] === "1" ? true : false;
        this.OpenVendorReturns = claims["Open Vendor Returns"] === "1" ? true : false;
        this.OpenDispatchTicketReport = claims["OpenDispatchTicketReport"] === "1" ? true : false;
        this.OpenQuotes = claims["OpenQuotes"] === "1" ? true : false;
        this.OpenClosedContract = claims["OpenClosedContract"] === "1" ? true : false;
        this.OracleVendorSetup = claims["OracleVendorSetup"] === "1" ? true : false;
        this.OverridePurchaseOrderLocks = claims["Override Purchase Order Locks"] === "1" ? true : false;
        this.PartBoughtSoldReport = claims["PartBoughtSoldReport"] === "1" ? true : false;
        this.PayInvoiceBills = claims["PayInvoiceBills"] === "1" ? true : false;
        this.POReport = claims["POReport"] === "1" ? true : false;
        this.POBillsCredits = claims["PoBillsCredits"] === "1" ? true : false;
        this.ZuggitPricing = claims["ZuggitPricing"] === "1" ? true : false;

        this.PosttoQuickbooks = claims["PosttoQuickbooks"] === "1" ? true : false;
        this.ProspectReport = claims["ProspectReport"] === "1" ? true : false;
        this.PurchaseOrderSummary = claims["Purchase Order Summary"] === "1" ? true : false;
        this.QuoteReport = claims["QuoteReport"] === "1" ? true : false;
        this.QuotesPendingApproval = claims["Quotes Pending Approval"] === "1" ? true : false;
        this.QuoteSummary = claims["QuoteSummary"] === "1" ? true : false;
        this.ReceiveMoreQuantityThenOrdered = claims["ReceiveMoreQuantityThenOrdered"] === "1" ? true : false;
        this.ReceiveParts = claims["ReceiveParts"] === "1" ? true : false;
        this.RemoveHold = claims["RemoveHold"] === "1" ? true : false;
        this.RequestTimeOff = claims["RequestTimeOff"] === "1" ? true : false;
        this.SaveAndClear = claims["SaveAndClear"] === "1" ? true : false;
        this.SetCompanyPartPrice = claims["SetCompanyPartPrice"] === "1" ? true : false;
        this.SetDispatchToBilled = claims["SetDispatchToBilled"] === "1" ? true : false;
        this.SetDispatchToCanceled = claims["SetDispatchToCanceled"] === "1" ? true : false;
        this.SetDispatchToClosed = claims["SetDispatchToClosed"] === "1" ? true : false;
        this.SetDispatchToMerged = claims["SetDispatchToMerged"] === "1" ? true : false;
        this.SetDispatchToReadyForBilling = claims["SetDispatchToReadyForBilling"] === "1" ? true : false;
        this.SetJobBackToService = claims["SetJobBackToService"] === "1" ? true : false;
        this.SetOrderToCompleted = claims["SetOrderToCompleted"] === "1" ? true : false;
        this.SetToApproved_Conditionally = claims["Set to Approved (Conditionally)"] === "1" ? true : false;
        this.SkipInvoiceChecklist = claims["Skip Invoice Checklist"] === "1" ? true : false;
        this.StockReplenishment = claims["StockReplenishment"] === "1" ? true : false;
        this.TaxableCheckbox = claims["TaxableCheckbox"] === "1" ? true : false;
        this.RecalculateButtonAccess = claims["RecalculateButtonAccess"] === "1" ? true : false;
        this.TaxReport = claims["TaxReport"] === "1" ? true : false;
        this.InvoiceProfitabilityGroupingReport = claims["InvoiceProfitabilityGroupingReport"] === "1" ? true : false;
        this.TechHours = claims["Tech Hours"] === "1" ? true : false;
        this.TechStatSummary = claims["Tech Stat Summary"] === "1" ? true : false;
        this.TechHoursReport = claims["TechHoursReport"] === "1" ? true : false;
        this.TopPartsBoughtSoldReport = claims["TopPartsBoughtSoldReport"] === "1" ? true : false;
        this.TopPartsReport = claims["TopPartsReport"] === "1" ? true : false;
        this.ViewEmployeePortal = claims["View Employee Portal"] === "1" ? true : false;
        this.ViewConstruction = claims["ViewConstruction"] === "1" ? true : false;
        this.ViewConstructionLabor = claims["ViewConstructionLabor"] === "1" ? true : false;
        this.ViewConstructionPOInformation = claims["ViewConstructionPOInformation"] === "1" ? true : false;
        this.ViewConstructionSubPOInformation = claims["ViewConstructionSubPOInformation"] === "1" ? true : false;
        this.ViewConstructionSubPOInformationApprove = claims["ViewConstructionSubPOInformationApprove"] === "1" ? true : false;
        this.ViewContractHistory = claims["ViewContractHistory"] === "1" ? true : false;
        this.ViewContractInfo = claims["ViewContractInfo"] === "1" ? true : false;
        this.ViewConstPMBoard = claims["ViewConstPMBoard"] === "1" ? true : false;
        this.ViewCustomers = claims["ViewCustomers"] === "1" ? true : false;
        this.ViewDispatchBoard = claims["ViewDispatchBoard"] === "1" ? true : false;
        this.ViewDispatchBoardFG2 = claims["ViewDispatchBoardFG2"] === "1" ? true : false;
        this.ViewDispatchHistory = claims["ViewDispatchHistory"] === "1" ? true : false;
        this.ViewEmployeeMaintenance = claims["ViewEmployeeMaintenance"] === "1" ? true : false;
        this.ViewEmployeeSecureInformation = claims["ViewEmployeeSecureInformation"] === "1" ? true : false;
        this.ViewExpenses = claims["ViewExpenses"] === "1" ? true : false;
        this.ViewInvoices = claims["ViewInvoices"] === "1" ? true : false;
        this.ViewJobInformation = claims["ViewJobInformation"] === "1" ? true : false;
        this.ViewOrders = claims["ViewOrders"] === "1" ? true : false;
        this.ViewOthersEmployeeNotes = claims["ViewOthersEmployeeNotes"] === "1" ? true : false;
        this.ViewParts = claims["ViewParts"] === "1" ? true : false;
        this.ViewPayrollandTimesheets = claims["ViewPayrollandTimesheets"] === "1" ? true : false;
        this.ViewQuotes = claims["ViewQuotes"] === "1" ? true : false;
        this.ViewSupplier = claims["ViewSupplier"] === "1" ? true : false;
        this.SupplierProcurementEditOnly = claims["SupplierProcurementEditOnly"] === "1" ? true : false;
        this.EditThresholdBranchandWarehouseLevels = claims["EditThresholdBranchandWarehouseLevels"] === "1" ? true : false;
        this.WarehouseTransfers = claims["WarehouseTransfers"] === "1" ? true : false;
        this.WarnOnlyUnreceivedOrders = claims["Warn Only Unreceived Orders"] === "1" ? true : false;
        this.WarnBeforeClosingTab = claims["WarnBeforeClosingTab"] === "1" ? true : false;
        this.WeeklyServiceLaborReport = claims["WeeklyServiceLaborReport"] === "1" ? true : false;
        this.DispatchPMBoardConfirmations = claims["DispatchPMBoardConfirmations"] === "1" ? true : false;
        this.PostConstructionWarrantyReport = claims["PostConstructionWarrantyReport"] === "1" ? true : false;
        this.WIPReport = claims["WIPReport"] === "1" ? true : false;
        this.WrongPartsOrdered = claims["WrongPartsOrdered"] === "1" ? true : false;
        this.WrongPartsRequested = claims["WrongPartsRequested"] === "1" ? true : false;
        this.ZeroDollarOrders = claims["ZeroDollarOrders"] === "1" ? true : false;
        this.CreateLocations = claims["CreateLocations"] === "1" ? true : false;
        this.RemoveHold = claims["RemoveHold"] === "1" ? true : false;
        this.MaintainLMSRole = claims["Maintain LMS Role"] === "1" ? true : false;
        this.MaintainCostCenters = claims["Maintain Cost Centers"] === "1" ? true : false;
        this.MaintainDepartment = claims["Maintain Department"] === "1" ? true : false;
        this.ViewCustomerAutomation = claims["ViewCustomerAutomation"] === "1" ? true : false;
        this.EditInventoryContractPrice = claims["EditInventoryContractPrice"] === "1" ? true : false;
        this.OverrideContractPrice = claims["OverrideContractPrice"] === "1" ? true : false;

        this.EditLocation = claims["EditLocation"] === "1" ? true : false;
        this.UpdateLocationDivision = claims["Update Location Division"] === "1" ? true : false;
        this.EditBillingCodes = claims["EditBillingCodes"] === "1" ? true : false;
        this.WIPContractReport = claims["ViewContractWIPRePort"] === "1" ? true : false;
        this.EditWIPCostAdjustments = claims["EditWIPCostAdjustments"] === "1" ? true : false;
        this.ActiveInvoiceDispute = claims["ActiveInvoiceDispute"] === "1" ? true : false;
        this.CreditMemoApproval = claims["CreditMemoApproval"] === "1" ? true : false;
        this.VehicleConfidentialDocument = claims["VehicleConfidentialDocument"] === "1" ? true : false;
        this.MonthEndDrawRecost = claims["MonthEndDrawRecost"] === "1" ? true : false;
        this.MonthEndDrawReCostFinalizeDraw = claims["MonthEndDrawReCostFinalizeDraw"] === "1" ? true : false;
        if ( claims["SearchDispatchs"] ) {
            this.SearchDispatchs = claims["SearchDispatchs"]
        } //User Settings
        if ( claims["DispatchBoardStatusWidth"] ) {
            this.DispatchBoardStatusWidth = claims["DispatchBoardStatusWidth"]
        }
        this.EditVehicleNote = claims["EditVehicleNote"] === "1" ? true : false;
        this.DeleteVehicleNote = claims["DeleteVehicleNote"] === "1" ? true : false;
        this.TestRightNo = false;
        this.TestRightYes = true;
        this.PriceChangeBenefit = claims["PriceChangeBenefit"] === "1" ? true : false;
        this.MarkProjectComplete = claims["MarkProjectComplete"] === "1" ? true : false;
        this.isBidsheetAdmin = claims["BidsheetAdmin"] === "1" ? true : false;
        this.isBidsheetViewerOnly = claims["BidsheetViewOnly"] === "1" ? true : false;
        this.canEditOwnBidsheet = claims["EditOwnBidsheet"] === "1" ? true : false;
        this.canEditAdminLaborRate = claims["EditLaborRate"] === "1" ? true : false;
        this.canEditBidsheetGeneralValues = claims["BidsheetGeneralValue"] === "1" ? true : false;
        this.editDeleteApprovedDispatchLabor = claims["EditDeleteApprovedDispatchLabor"] === "1" ? true : false;
        this.viewCustomerCustomForms = claims["ViewCustomerCustomForms"] === "1" ? true : false;
        this.editCustomerCustomForms = claims["EditCustomerCustomForms"] === "1" ? true : false;
        this.ViewHiddenQuoteAttachments = claims["ViewHiddenQuoteAttachments"] === "1" ? true : false;

        //Cycle Count Features
        this.inventoryCountAdmin = claims["InventoryCountAdmin"] === "1" ? true : false;
        this.canCommitInventoryCount = claims["CommitCycleCount"] === "1" ? true : false;
        this.canCreateInventoryCount = claims["CreateCycleCount"] === "1" ? true : false;
        this.canEditInventoryCount = claims["EditCycleCount"] === "1" ? true : false;
        this.canViewCycleCounting = claims["CanViewCycleCounting"] === "1" ? true : false;
        this.canCancelAnyCycleCount = claims["CanCancelAnyCycleCount"] === "1" ? true : false;

        //Report Permissions
        this.purchaseDashboardReport = claims["PurchaseDashboardReport"] === "1";
        this.warehouseDashboardReport = claims["WarehouseDashboardReport"] === "1";
        //Zuggit Report Permissions
        this.zuggitPurchasingDashboardReport = claims["zuggitPurchasingDashboardReport"] === "1";
        this.zuggitInvoiceSales2Report = claims["zuggitInvoiceSales2Report"] === "1";
        this.zuggitARNotesReport = claims["zuggitARNotesReport"] === "1";
        this.zuggitCustomerPaymentReport = claims["zuggitCustomerPaymentReport"] === "1";
        this.zuggitInvoiceCreatedSummaryReport = claims["zuggitInvoiceCreatedSummaryReport"] === "1";
        this.zuggitDispatchSummaryReport = claims["zuggitDispatchSummaryReport"] === "1";
        this.zuggitEquipmentHistoryReport = claims["zuggitEquipmentHistoryReport"] === "1";
        this.zuggitWrongPartsRequestedReport = claims["zuggitWrongPartsRequestedReport"] === "1";
        this.zuggitQuoteSummaryReport = claims["zuggitQuoteSummaryReport"] === "1";
        this.zuggitPurchaseOrderReport = claims["zuggitPurchaseOrderReport"] === "1";
        this.zuggitPurchaseOrderBillReport = claims["zuggitPurchaseOrderBillReport"] === "1";
        this.zuggitWrongPartsOrderedReport = claims["zuggitWrongPartsOrdered"] === "1";
        this.zuggitInventoryQuantityCostReport = claims["zuggitInventoryQuantityCostReport"] === "1";
        this.zuggitPartsActivityReport = claims["zuggitPartsActivityReport"] === "1";
        this.zuggitPartBoughtSoldReport = claims["zuggitPartBoughtSoldReport"] === "1";
        this.zuggitSupplierQueryReport = claims["zuggitSupplierQueryReport"] === "1";
        this.zuggitDailyReceivedByReport = claims["zuggitDailyReceivedByReport"] === "1";
        this.zuggitDailyReceivedByVendorCreditReport = claims["zuggitDailyReceivedByVendorCreditReport"] === "1";

        this.serverReferenceDataRefresh = claims["ServerReferenceDataRefresh"] === "1";
        this.ViewZuggitCPWidget = claims["ViewZuggitCPWidget"] === "1" ? true : false;
        this.POsAfterHours = claims["POsAfterHours"] === "1" ? true : false;
        this.ApproveClimateProsInvoice = claims["ApproveClimateProsInvoice"] === "1" ? true : false;
        this.CreateClimateProsScheduledDispatch = claims["CreateClimateProsScheduledDispatch"] === "1" ? true : false;
        
        this.canEditVendorCreditMemo = claims["EditVendorCreditMemo"] === "1" ? true : false;
        this.viewEditMobileReleaseVersions = claims["ViewEditMobileReleaseVersions"] === "1" ? true : false;


    }
    version: string;
    AccountReceivableSummary: boolean;
    ActiveMobileMapLink: boolean;
    AdminExpenseMaintenance: boolean;
    ARReport: boolean;
    AssetHistoryReport: boolean;
    BypassCustomerSigEnforcement: boolean;
    CanViewMobilePricing: boolean;
    ChangeStatusFrom_Bill_DiscreteReview: boolean;
    ClockinClockOutTime: boolean; // Clockin / ClockOutTime
    ClosedJobInfoReport: boolean;
    CollectionBulkUpload: boolean;
    BulkUploadInventory: boolean
    CommonInventory: boolean;
    CompanyCPI: boolean;
    CompanyCPM: boolean;
    CompanyCRS: boolean;
    ContractEditAdmin: boolean;
    CreateCPIDispatch: boolean;
    CreateCustomers: boolean;
    CreateEmployeeNote: boolean;
    CreateInvoices: boolean;
    CreateNewParts: boolean;
    EditPartNumber: boolean;
    EditInvoiceChecklist: boolean;
    EditOnCallRegion: boolean;
    CreditMemoApprovalTaxesOnly: boolean;
    CurrentJobsReport: boolean;
    CustomerAddressList: boolean;
    CustomerContractDates: boolean;
    CustomerPaymentReport: boolean;
    CustomerSalesSummaryReport: boolean;
    CustomerStatementReport: boolean;
    CustomerStatistics: boolean;
    EditCustomerAutomation: boolean;
    DefaultEditMode: boolean;
    DeleteCustomer: boolean;
    DeleteDispatch: boolean;
    DeleteInvoice: boolean;
    DeleteLocation: boolean;
    DeleteOrder: boolean;
    DeleteQuote: boolean;
    DispacthStatusHistoryReport: boolean;
    DispatchEquipmentHistory: boolean;
    DispatchStatusGauge: boolean;
    DispatchAssignedInReadyForBillingStatusGT1Day: boolean; //DispatchAssignedInReadyForBillingStatus>1Day
    DispatchCreatedReport: boolean;
    DispatchLaborReport: boolean;
    DispatchReport: boolean;
    DontShowSafetyWarning: boolean;
    DuplicateDispatch: boolean;
    DuplicateInvoices: boolean;
    EditOwnClockedTime: boolean;
    EditUsedPartQty: boolean;
    EditAccountNumbers: boolean;
    EditCategoriesandType: boolean;
    EditClosedDispatch: boolean;
    EditCompletedOrder: boolean;
    EditContractPrice: boolean;
    EditCustomerSensitiveData: boolean;
    EditInvoiceCost: boolean;
    EditInvoiceDate: boolean;
    EditFullyReceivedOrder: boolean;
    CreateConstructionCredits: boolean;
    EditClosedDispatchOrder: boolean;
    EditLabor: boolean;
    EditOthersNotes: boolean;
    EditPartsHistory: boolean;
    EditPartQuantity: boolean;
    EditPostedInvoice: boolean;
    EditPriority: boolean;
    EditProjectManager: boolean;
    EditReadyForBillingConstruction: boolean;
    EditReadyToPost: boolean;
    EditSecurityTemplates: boolean;
    EditStatus: boolean;
    EditWrongParts: boolean;
    EditThresholdAlternateNumbers: boolean;
    EditPurchaser: boolean;
    EmpBreakdownReport: boolean;
    EmpCensusReport: boolean;
    EmployeeErrorsReport: boolean;
    EnableTabbedDesktopFeatures: boolean;
    EnterBills: boolean;
    EquipmentHistoryReport: boolean;
    ExpenseMaintenanceSuperUser: boolean;
    ExportCorrigo: boolean;
    ExportCostco: boolean;
    ExportEmployeeList: boolean;
    ExportEmployeeListCon: boolean;
    ExportRoundys: boolean;
    FG2RegularAccess: boolean;
    FieldJetXEnabled: boolean;
    FinancialLockOverride: boolean;
    InventoryQuantityCostReport: boolean;
    InvoiceDisputes: boolean;
    InvoiceLineCost: boolean;
    InvoiceNeedsApproval: boolean;
    InvoiceSalesSummary: boolean;
    InvoiceCreatedReport: boolean;
    InvoicePaymentsReport: boolean;
    InvoiceSalesReport: boolean;
    InvoiceStatusHistoryReport: boolean;
    InventoryThresholdsReport:boolean;
    LaborLineUnionReport: boolean;
    MaintainBenefitMapping: boolean;
    MaintainAssets: boolean;
    MaintainCommissions: boolean;
    MaintainCompanyDefaults: boolean;
    MaintainCostCenters: boolean;
    MaintainCustomerBillingCodeMatrix: boolean;
    MaintainCustomerPartPricing: boolean;
    MaintainCustomers: boolean;
    MaintainDepartment: boolean;
    MaintainDispatches: boolean;
    MaintainEmployeeInfo: boolean;
    MaintainExpenses: boolean;
    MaintainFeatures: boolean;
    MaintainInventory: boolean;
    MaintainInvoices: boolean;
    MaintainLMSRole: boolean;
    MaintainMobileCommunications: boolean;
    MaintainMobileCustomForms: boolean;
    MaintainParts: boolean;
    MaintainUserCreditMemoProfiles: boolean;
    MaintainZebraPrinters: boolean;
    MergeParts: boolean;
    MaintainPayroll: boolean;
    BulkInsertPayroll: boolean;
    MaintainPayrollandTimesheets: boolean;
    MaintainQuotes: boolean;
    UseLocationRateOnApproval: boolean;
    MaintainSuppliers: boolean;
    MaintainSystemEvents: boolean;
    MaintainTimeOffRequests: boolean;
    MaintainUserLicenseMapping: boolean;
    MaintainUserSessions: boolean;
    MaintainVehiclePartRequests: boolean;
    MaintainVehicles: boolean;
    MaintianOrders: boolean;
    MinimumProfitOverrideApproval: boolean;
    MonthlyInvoiceSalesDetail: boolean;
    NoSaveSuccessful: boolean;
    OpenContracts: boolean;
    PendingChangeOrders: boolean;
    OpenVendorReturns: boolean;
    OpenDispatchTicketReport: boolean;
    OpenClosedContract: boolean;
    OpenQuotes: boolean;
    OracleVendorSetup: boolean;
    OverridePurchaseOrderLocks: boolean;
    PartBoughtSoldReport: boolean;
    PayInvoiceBills: boolean;
    POReport: boolean;
    POBillsCredits: boolean;
    ZuggitPricing: boolean;
    PosttoQuickbooks: boolean;
    ProspectReport: boolean;
    PriceChangeBenefit: boolean;
    PurchaseOrderSummary: boolean;
    QuoteReport: boolean;
    QuotesPendingApproval: boolean;
    QuoteSummary: boolean;
    ReceiveMoreQuantityThenOrdered: boolean;
    ReceiveParts: boolean;
    RemoveHold: boolean;
    RequestTimeOff: boolean;
    StockReplenishment: boolean;
    SaveAndClear: boolean;
    SetCompanyPartPrice: boolean;
    SetDispatchToBilled: boolean;
    SetDispatchToCanceled: boolean;
    SetDispatchToClosed: boolean;
    SetDispatchToMerged: boolean;
    SetDispatchToReadyForBilling: boolean;
    SetJobBackToService: boolean;
    SetOrderToCompleted: boolean;
    SetToApproved_Conditionally: boolean; //Invoice
    SkipInvoiceChecklist: boolean;
    TaxableCheckbox: boolean;
    RecalculateButtonAccess: boolean;
    TaxReport: boolean;
    InvoiceProfitabilityGroupingReport: boolean;
    TechHours: boolean;
    TechStatSummary: boolean;
    TechHoursReport: boolean;
    TopPartsBoughtSoldReport: boolean;
    TopPartsReport: boolean;
    ViewConstruction: boolean;
    ViewEmployeePortal: boolean;
    ViewConstructionLabor: boolean;
    ViewConstructionPOInformation: boolean;
    ViewConstructionSubPOInformation: boolean;
    ViewConstructionSubPOInformationApprove: boolean;
    ViewContractHistory: boolean;
    ViewContractInfo: boolean;
    ViewConstPMBoard: boolean;
    ViewCustomers: boolean;
    ViewDispatchBoard: boolean;
    ViewDispatchBoardFG2: boolean;
    ViewDispatchHistory: boolean;
    ViewEmployeeMaintenance: boolean;
    ViewEmployeeSecureInformation: boolean;
    ViewExpenses: boolean;
    ViewInvoices: boolean;
    ViewJobInformation: boolean;
    ViewOrders: boolean;
    ViewOthersEmployeeNotes: boolean;
    ViewParts: boolean;
    ViewPayrollandTimesheets: boolean;
    ViewQuotes: boolean;
    ViewSupplier: boolean;
    SupplierProcurementEditOnly: boolean;
    EditThresholdBranchandWarehouseLevels: boolean;
    WarehouseTransfers: boolean;
    WarnOnlyUnreceivedOrders: boolean;
    WarnBeforeClosingTab: boolean;
    WeeklyServiceLaborReport: boolean;
    DispatchPMBoardConfirmations: boolean;
    PostConstructionWarrantyReport: boolean;
    WIPReport: boolean;
    WrongPartsOrdered: boolean;
    WrongPartsRequested: boolean;
    ZeroDollarOrders: boolean;
    TestRightNo: boolean;
    TestRightYes: boolean;
    CreateLocations: boolean;
    EditLocation: boolean;
    ViewCustomerAutomation: boolean;
    EditInventoryContractPrice: boolean;
    OverrideContractPrice: boolean;
    UpdateLocationDivision: boolean;
    EditBillingCodes: boolean;
    WIPContractReport: boolean;
    EditWIPCostAdjustments: boolean;
    SearchDispatchs: String;
    DispatchBoardStatusWidth: Number = 250;
    ActiveInvoiceDispute: boolean;
    CreditMemoApproval: boolean;
    VehicleConfidentialDocument: boolean;
    MonthEndDrawRecost: boolean;
    MonthEndDrawReCostFinalizeDraw: boolean;
    EditVehicleNote: boolean;
    DeleteVehicleNote: boolean;
    MarkProjectComplete: boolean;
    isBidsheetAdmin: boolean;
    isBidsheetViewerOnly: boolean;
    canEditOwnBidsheet: boolean;
    canEditAdminLaborRate: boolean;
    canEditBidsheetGeneralValues: boolean;
    editDeleteApprovedDispatchLabor: boolean;
    viewCustomerCustomForms: boolean;
    editCustomerCustomForms: boolean;
    canCommitInventoryCount: boolean;
    inventoryCountAdmin: boolean;
    canCreateInventoryCount: boolean;
    canEditInventoryCount: boolean;
    canViewCycleCounting: boolean;
    canCancelAnyCycleCount: boolean;
    purchaseDashboardReport: boolean;
    warehouseDashboardReport: boolean;
    ViewHiddenQuoteAttachments: boolean;
    serverReferenceDataRefresh: boolean;
    ViewZuggitCPWidget: boolean;
    POsAfterHours: boolean;
    ApproveClimateProsInvoice: boolean;
    CreateClimateProsScheduledDispatch: boolean;
    zuggitPurchasingDashboardReport: boolean;
    zuggitInvoiceSales2Report: boolean;
    zuggitARNotesReport: boolean;
    zuggitCustomerPaymentReport: boolean;
    zuggitInvoiceCreatedSummaryReport: boolean;
    zuggitDispatchSummaryReport: boolean;
    zuggitEquipmentHistoryReport: boolean;
    zuggitWrongPartsRequestedReport: boolean;
    zuggitQuoteSummaryReport: boolean;
    zuggitPurchaseOrderReport: boolean;
    zuggitPurchaseOrderBillReport: boolean;
    zuggitWrongPartsOrderedReport: boolean;
    zuggitInventoryQuantityCostReport: boolean;
    zuggitPartsActivityReport: boolean;
    zuggitPartBoughtSoldReport: boolean;
    zuggitSupplierQueryReport: boolean;
    zuggitDailyReceivedByReport: boolean;
    zuggitDailyReceivedByVendorCreditReport: boolean;
    canEditVendorCreditMemo: boolean;
    viewEditMobileReleaseVersions: boolean;
}
